module.exports = __webpack_public_path__ + "static/media/brennstoff.15516d23.m4a";